export const config = {
    form: {
        loadDate: '',
        taskNo: ''
    },
    rules: {
        loadDate: [{
            required: true,
            message: '请选择装车时间',
            trigger: 'blur'
        }],
        taskNo: [{
            required: true,
            message: '请输入运单号',
            trigger: 'blur'
        }]
    }
};
